<template>
  <div v-if="validated && !isLive">
    <b-card class="text-center" border-variant="primary">

      <h4 class="fs-2 fw-bold">
        This research report on a new structured product from <b>{{ provider }}</b><br>
        is due to be published on StrucutredEdge (UK) {{ publicationdate === '' ? 'soon' : 'on ' + publicationdate }}<br><br>
        When the report has been published it will be available via this link
      </h4>
    </b-card>
  </div>
  <div v-else-if="validated && isLive">
    <b-card class="text-center" border-variant="primary">
      <h4 v-if="isWeekly" class="fs-2 fw-bold">
        Different text
        <br><br>
      </h4>
      <h4 class="fs-2 fw-bold">
        <b>{{ isSingularReport ? 'Research report' : response.REPORTS.split(",").length + ' research reports'}} published on StructuredEdge </b><br><br>
        {{ isSingularReport ? 'This report is' : 'These reports are' }} intended for financial professionals only. <br>
        To view {{ isSingularReport ? 'it' : 'them' }}  you need to be registered with the Structured Edge research service. <br>
        <br>
        Please <router-link :to="{ name: 'register'}">register</router-link> with us or for more information visit the Quick start.
      </h4>
      <!-- email content row -->
      <br>
      <b-table
        :items="reportsTable"
        :fields="fields"
        show-empty
        empty-text="No products available"
        thead-class="d-none"
      >
        <template #cell(image)="data">
          <img
            loading="lazy"
            width="70"
            :src="`${baseURL}servethumbnail.cfm?id=${data.item.detailsId}`"
          >
        </template>
        <template #cell(summary)="data">
          {{ data.item.summary }}<br><br>
          <b-button
            variant="primary"
            :href="`/product/report/${data.item.reportNumber}`"
          >View product</b-button>
        </template>
      </b-table>
      <br>
      To access one of the research reports please click on a link above.
    </b-card>
  </div>
</template>

<script>

import { BCard, BTable, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'PreLink',
  components: {
    BCard,
    BTable,
    BButton,
  },
  props: {
    mode: {
      type: String,
      default: 'databaseid',
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BACKEND_PATH,
      validated: false,
      isSingularReport: false,
      message: '',
      isLive: false,
      provider: '',
      publicationdate: '',
      isWeekly: false,
      response: {},
      reportsTable: [],
      fields: [
        {
          key: 'image',
          label: ' ',
          sortable: false,
          thStyle: { width: '5%' },
        },
        {
          key: 'summary',
          sortable: false,
          thStyle: { width: '5%' },
        },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
    ]),
  },
  created() {
    this.checkReportState()
  },
  methods: {
    checkReportState() {
      let id = ''
      let password = ''

      if (this.mode === 'databaseid') {
        id = this.$route.params.databaseid
        password = this.$route.params.password
      } else if (this.mode === 'previewid') {
        id = this.$route.params.previewid
      } else if (this.mode === 'reportnumber') {
        id = this.$route.params.reportNumber
      }

      this.$http.get('reportflavours.cfc', {
        params: {
          method: 'prelink',
          mode: this.mode,
          id,
          password,
        },
      })
        .then(response => {
          const { data } = response
          if (data.SUCCESS) {
            const isValidReport = typeof data.REPORTS === 'number' || (typeof data.REPORTS === 'string' && /^\d+$/.test(data.REPORTS))
            this.isSingularReport = isValidReport

            if (data.ISLIVE && isValidReport && this.isLoggedIn) {
              this.$router.push({ name: 'product-report', params: { reportNumber: data.REPORTS } })
              return
            }
            this.isLive = data.ISLIVE
            this.provider = data.PROVIDER
            this.publicationdate = data.PUBLICATIONDATE
            this.isWeekly = data.ISWEEKLY
            this.response = data
            this.reportsTable = data.REPORTROWS
            this.validated = true
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' })
        })
    },
  },
}
</script>
